/* eslint-disable */
import { Box, Divider, Stack, Typography, darken } from '@mui/material';
import React, { useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { styled } from '@mui/material/styles';

import ColoredCheckBox from './ColoredCheckBox';

const CalendarBox = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  marginLeft: theme.spacing(1),
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    margin: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
    borderRadius: '3px',
  },
}));

const CalendarGroups = ({ robotData, onToggleGroup }) => {
  const [robotEntries, setRobotEntries] = useState(Object.entries(robotData));

  useUpdateEffect(() => {
    setRobotEntries(Object.entries(robotData));
  }, [robotData]);

  return (
    <Stack direction="row" height="100%">
      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
      <CalendarBox>
        <Typography variant="h6">로봇 그룹</Typography>
        {robotEntries.length > 0 &&
          robotEntries.map(([k, { name, checked }], idx) => (
            <ColoredCheckBox
              key={k}
              id={k}
              label={`${name}`}
              index={idx}
              onChange={onToggleGroup(k)}
              checked={checked}
            />
          ))}
      </CalendarBox>
    </Stack>
  );
};

export default CalendarGroups;
